
        import * as module0 from '$components/gallery_toggle.js';import * as module1 from '$components/half_tone.js';import * as module2 from '$components/portfolio_image.css'
        const modules = {
            "gallery_toggle.js": module0,
            "half_tone.js": module1,
            "portfolio_image.css": module2,
        };
        export default modules;
      